import { QueryClient } from '@tanstack/react-query';

/**
 * React Query configuration for optimal caching and performance
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes by default
      staleTime: 5 * 60 * 1000,
      // Keep unused data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed requests once
      retry: 1,
      // Refetch on window focus for fresh data
      refetchOnWindowFocus: true,
      // Don't refetch on reconnect (will happen on focus anyway)
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry mutations once
      retry: 1,
    },
  },
});

// Query keys for consistent cache management
// Note: Domain-specific query keys are now exported from each domain's hook files
// This is kept for backward compatibility
export const queryKeys = {
  patients: {
    all: ['patients'] as const,
    list: (params?: Record<string, any>) => ['patients', 'list', params] as const,
    detail: (id: string) => ['patients', 'detail', id] as const,
    search: (query: string) => ['patients', 'search', query] as const,
  },
  tests: {
    all: ['tests'] as const,
    list: () => ['tests', 'list'] as const,
    categories: () => ['tests', 'categories'] as const,
  },
  referrals: {
    all: ['referrals'] as const,
    list: () => ['referrals', 'list'] as const,
    detail: (id: string) => ['referrals', 'detail', id] as const,
  },
  dashboard: {
    metrics: () => ['dashboard', 'metrics'] as const,
    assignments: () => ['dashboard', 'assignments'] as const,
    queues: () => ['dashboard', 'queues'] as const,
  },
  invoices: {
    all: ['invoices'] as const,
    list: (params?: Record<string, any>) => ['invoices', 'list', params] as const,
    detail: (id: string) => ['invoices', 'detail', id] as const,
  },
};
